/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_RevokeInputs */

const en_us2_coaching_revoke = /** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel invitation`)
};

const pt_br2_coaching_revoke = /** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar convite`)
};

const pt_pt2_coaching_revoke = /** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar convite`)
};

/** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */
const es_419_coaching_revoke = en_us2_coaching_revoke;

/** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */
const fr_fr2_coaching_revoke = en_us2_coaching_revoke;

/** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */
const de_de2_coaching_revoke = en_us2_coaching_revoke;

/** @type {(inputs: Coaching_RevokeInputs) => LocalizedString} */
const it_it2_coaching_revoke = en_us2_coaching_revoke;

/**
* | output |
* | --- |
* | "Cancel invitation" |
*
* @param {Coaching_RevokeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_revoke = /** @type {((inputs?: Coaching_RevokeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_RevokeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_revoke(inputs)
	if (locale === "es-419") return es_419_coaching_revoke(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_revoke(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_revoke(inputs)
	if (locale === "de-DE") return de_de2_coaching_revoke(inputs)
	if (locale === "it-IT") return it_it2_coaching_revoke(inputs)
	return en_us2_coaching_revoke(inputs)
});
export { coaching_revoke as "coaching.revoke" }